import React from 'react';
import { SunIcon, MoonIcon, MenuIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface NavbarProps {
  darkMode: boolean;
  toggleDarkMode: () => void;
}
export const Navbar = ({
  darkMode,
  toggleDarkMode
}: NavbarProps) => {
  return <header className="w-full py-4 px-6 md:px-12 flex items-center justify-between border-b border-gray-200 dark:border-gray-800" data-id="element-114">
      <div className="flex items-center" data-id="element-115">
        <Link to="/" className="flex items-center" data-id="element-116">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pLF1xF3x24A3EHrkGHQH5h/RH_Logo%2C_No_Text.png" alt="RootHealth Logo" className="h-8 mr-2" data-id="element-117" />
          <span className="text-xl font-bold text-charcoal-700 dark:text-gray-100" data-id="element-118">
            RootHealth
          </span>
        </Link>
      </div>
      <div className="hidden md:flex items-center space-x-8" data-id="element-119">
        <a href="#how-it-works" className="text-sm font-medium hover:text-green-600 dark:hover:text-green-400 transition-colors" data-id="element-120">
          How It Works
        </a>
        <a href="#features" className="text-sm font-medium hover:text-green-600 dark:hover:text-green-400 transition-colors" data-id="element-121">
          Features
        </a>
        <a href="#pricing" className="text-sm font-medium hover:text-green-600 dark:hover:text-green-400 transition-colors" data-id="element-122">
          Pricing
        </a>
        <a href="/team" className="text-sm font-medium hover:text-green-600 dark:hover:text-green-400 transition-colors" data-id="element-123">
          Team
        </a>
        <a href="#contact" className="text-sm font-medium hover:text-green-600 dark:hover:text-green-400 transition-colors" data-id="element-124">
          Contact
        </a>
      </div>
      <div className="flex items-center space-x-4" data-id="element-125">
        <button onClick={toggleDarkMode} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-126">
          {darkMode ? <SunIcon size={20} data-id="element-127" /> : <MoonIcon size={20} data-id="element-128" />}
        </button>
        <button className="md:hidden" aria-label="Menu" data-id="element-129">
          <MenuIcon size={24} data-id="element-130" />
        </button>
      </div>
    </header>;
};